import { Card, CardContent, Skeleton, Stack } from '@mui/material';

export const ContractCardSkeleton = () => {
  return (
    <Card sx={{ width: '100%', borderRadius: 0 }} variant="outlined">
      <Stack
        direction="row"
        spacing={1}
        sx={{ padding: 0.5, backgroundColor: 'lightgrey' }}
      >
        <Skeleton variant="rectangular" width="30%" />
      </Stack>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" width="100%">
          <Stack direction="row" justifyContent="flex-start" width="100%">
            <Stack direction="column" spacing={1} width="100%">
              <Skeleton variant="rectangular" width="30%" />
              <Stack direction="column" width="100%" spacing={1}>
                <Skeleton variant="text" width="80%" />
                <Skeleton variant="text" width="80%" />
              </Stack>
            </Stack>
            <Skeleton variant="circular" width={40} height={40} />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
